import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=06fdccc6&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=06fdccc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fdccc6",
  null
  
)

export default component.exports